import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {isDesktop, isMobile} from "@/Helpers/Function";
import {Breadcrumbs} from "@mui/material";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Pages/Collections/scss/northern-lights.scss';

class NorthernLights extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {stores = {}, uploadUrl = ''} = this.props;
        const {collectionsStore = {}} = stores;

        return <section className={`section section__northern-lights`}>
            <div className={`breadcrumbs`}>
                <div className="container">
                    <Breadcrumbs
                        maxItems={3}
                        itemsAfterCollapse={3}
                    >
                        <Link className={`breadcrumbs__link`} href={`/`}>
                            Главная
                        </Link>
                        <Link className={`breadcrumbs__link`} href={`/collections`}>
                            Коллекции
                        </Link>
                        <p className={`breadcrumbs__text`}>
                            Северное сияние
                        </p>
                    </Breadcrumbs>
                </div>
            </div>
            <div className={`collections-lp collections-lp__northern-lights`}>
                <div className={`container`}>
                    <h1 className={`h1`}>Коллекция &laquo;Северное сияние&raquo;</h1>
                    <div className={`northern-lights`}>
                        <div className={`northern-lights__video-main`}>
                            {isMobile() ?
                                <video id={`video_northern_lights_main`}
                                       preload={`none`}
                                       width={`100%`}
                                       muted={`muted`}
                                       autoPlay
                                       loop
                                       poster={`/storage/img/collections/severnoe-siyanie/video_1.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-prezentaciya_768x_2.5mbps.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-prezentaciya_768x_2.5mbps.webm`}
                                        type={`video/webm`} />
                                </video>
                                :
                                <video id={`video_northern_lights_main`}
                                       preload={`none`}
                                       width={`100%`}
                                       muted={`muted`}
                                       autoPlay
                                       loop
                                       poster={`/storage/img/collections/severnoe-siyanie/video_1.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-prezentaciya_1330x_2.5mbps.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-prezentaciya_1330x_2.5mbps.webm`}
                                        type={`video/webm`} />
                                </video>
                            }
                            <div className={`video-control`}
                                 onClick={() => collectionsStore.mediaNorthernLightsMainPlayPause()}>
                                {collectionsStore.videoNorthernLightsPlaySvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => collectionsStore.mediaNorthernLightsMainPlay()}></div>
                                    </>
                                    :
                                    <>
                                        {collectionsStore.videoNorthernLightsMainPlayPauseFlag ?
                                            <div className={`gg-pause-button`}
                                                 onClick={() => collectionsStore.mediaNorthernLightsMainPlay()}></div>
                                            : null
                                        }
                                    </>
                                }
                                <div className={`volume`} onClick={() => collectionsStore.mediaNorthernLightsVolume()}>
                                    {collectionsStore.videoNorthernLightsVolumeSvg ?
                                        <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                                        :
                                        <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={`northern-lights-description`}>
                            <p>
                                В&nbsp;преддверии новогодних праздников нам хотелось порадовать вас чем-то
                                особенным...
                                {isDesktop() ?
                                    <br /> : null
                                }
                                И&nbsp;мы&nbsp;с&nbsp;радостью представляем вам линейку серебряных
                                украшений &laquo;Северное сияние&raquo;!
                                {isDesktop() ?
                                    <br /> : null
                                }
                                Коллекцию, вдохновлённую волшебством, блеском серебра и&nbsp;игрой камней.
                            </p>
                        </div>
                        <div className={`magic-of-emotions`}>
                            <div className={`magic-of-emotions__img`}>
                                <img src={`/storage/img/collections/severnoe-siyanie/banner.jpg`} alt={`Изображение`}
                                     title={`Изображение`} />
                            </div>
                            <div className={`magic-of-emotions__content`}>
                                <div className={`title`}>Магия эмоций от PLATINA</div>
                                <div className={`description`}>
                                    <p>
                                        В&nbsp;дизайне украшений коллекции &laquo;Северное сияние&raquo; нашли
                                        своё
                                        отражение самые модные и&nbsp;самые свежие тренды ювелирной моды.
                                        Многослойность композиции, подвесные элементы, пленительный блеск
                                        натуральных камней... и, конечно&nbsp;же, серебро.
                                    </p>
                                    <br />
                                    <p>
                                        Коллекция &laquo;Северное сияние&raquo;&nbsp;&mdash; это магия эмоций,
                                        чувств и&nbsp;настроений. Изысканное сплетение ювелирных образов,
                                        метафор
                                        и&nbsp;символов. Знакомых и&nbsp;узнаваемых, но&nbsp;в&nbsp;то&nbsp;же
                                        время
                                        магических, полных тайн и&nbsp;загадок. В&nbsp;этих изящных
                                        и&nbsp;утонченных украшениях каждый видит свой смысл и&nbsp;свою
                                        историю.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={`northern-lights__decoration`}>
                            <p className={`title`}>Украшения</p>
                            <div className={`decoration-wrapper`}>
                                <div className={`decoration-wrapper__item`}>
                                    <img src={`/storage/img/collections/severnoe-siyanie/655х425-1.jpg`}
                                         alt={`Кольца`}
                                         title={`Кольца`}
                                    />
                                    <div className={`cover-northern-lights`}>
                                        <p className={`cover-northern-lights__name`}>
                                            Кольца
                                        </p>
                                        <Link href={`/catalog/kolca/severnoe-siyanie?utm_content=kolca`}
                                                  className={`btn btn__white-northern-lights`}
                                        >
                                            Смотреть
                                        </Link>
                                    </div>
                                </div>
                                <div className={`decoration-wrapper__item`}>
                                    <img src={`/storage/img/collections/severnoe-siyanie/655х425-2.jpg`}
                                         alt={`Серьги`}
                                         title={`Серьги`}
                                    />
                                    <div className={`cover-northern-lights`}>
                                        <p className={`cover-northern-lights__name`}>
                                            Серьги
                                        </p>
                                        <Link href={`/catalog/sergi/severnoe-siyanie?utm_content=sergi`}
                                                  className={`btn btn__white-northern-lights`}
                                        >
                                            Смотреть
                                        </Link>
                                    </div>
                                </div>
                                <div className={`decoration-wrapper__item`}>
                                    <img src={`/storage/img/collections/severnoe-siyanie/655х425-3.jpg`}
                                         alt={`Подвески`}
                                         title={`Подвески`}
                                    />
                                    <div className={`cover-northern-lights`}>
                                        <p className={`cover-northern-lights__name`}>
                                            Подвески
                                        </p>
                                        <Link href={`/catalog/podveski/severnoe-siyanie?utm_content=podveski`}
                                                  className={`btn btn__white-northern-lights`}
                                        >
                                            Смотреть
                                        </Link>
                                    </div>
                                </div>
                                <div className={`decoration-wrapper__item`}>
                                    <img src={`/storage/img/collections/severnoe-siyanie/655х425-4.jpg`}
                                         alt={`Браслеты`}
                                         title={`Браслеты`}
                                    />
                                    <div className={`cover-northern-lights`}>
                                        <p className={`cover-northern-lights__name`}>
                                            Браслеты
                                        </p>
                                        <Link href={`/catalog/braslety/severnoe-siyanie?utm_content=braslety`}
                                                  className={`btn btn__white-northern-lights`}
                                        >
                                            Смотреть
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`interview-video`}>
                            {isMobile() ?
                                <video id={`video_northern_lights`}
                                       preload={`none`}
                                       width={`100%`}
                                       poster={`/storage/img/collections/severnoe-siyanie/video_2.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-interv'yu_768x_2.5mbps.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-interv'yu_768x_2.5mbps.webm`}
                                        type={`video/webm`} />
                                </video>
                                :
                                <video id={`video_northern_lights`}
                                       preload={`none`}
                                       width={`100%`}
                                       poster={`/storage/img/collections/severnoe-siyanie/video_2.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-interv'yu_1330x_2.5mbps.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/severnoe-siyanie/severnoe-siyanie-interv'yu_1330x_2.5mbps.webm`}
                                        type={`video/webm`} />
                                </video>
                            }
                            <div className={`interview__play`}
                                 onClick={() => collectionsStore.mediaNorthernLightsPlayPause()}
                            >
                                {collectionsStore.videoNorthernLightsSvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => collectionsStore.mediaNorthernLightsPlay()}></div>
                                    </>
                                    :
                                    <>
                                        {collectionsStore.videoNorthernLightsPlayPauseFlag ?
                                            <div className={`gg-pause-button`}
                                                 onClick={() => collectionsStore.mediaNorthernLightsPlay()}></div>
                                            : null
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        <div className={`gradient-bottom`}>
                            Дарите свою красоту миру с&nbsp;новыми украшениями от&nbsp;PLATINA.
                            Выбирайте лучшее и&nbsp;наслаждайтесь своим совершенством.
                            Каждый день.
                        </div>
                        <div className={`watch-jewelry`}>
                            <Link href={`/catalog/severnoe-siyanie?utm_content=catalog`}
                                      className={`btn btn__wish`}
                            >
                                Смотреть украшения
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    }
}

export default useWithStore(NorthernLights);
